export default __webpack_public_path__ + "static/media/IMG_7563.05543f97.JPG";